export const state = {
  isAuthenticated: false,
  user: null,
  error: null,
  loading: false,
  users: null,
  transfers: null,
  perPage: 10
}
